module.exports = __webpack_public_path__ + "img/core-2.6434771.png";